<template>
  <article class="d-flex position-relative mb-3">
    <a :href="`${link}`" class="Card-link Card-link--secondary stretched-link"></a>
    <div class="Post-image" :style="`background-image: url('${post.imagePath}')`"></div>
    <div class="p-3 p-md-3 w-100 min-w-0">
      <div class="row mb-2">
        <div class="col-md-9">
          <h2 class="h5 Post-header mb-2 mb-lg-0">{{ post.title | stringLimit(90) }}</h2>
        </div>
        <div class="col-md-3 text-md-right">
          <p v-if="post.date" class="h5 font-size-sm">{{ $date(post.date).format('L') }}</p>
        </div>
      </div>
      <h3 v-if="postInfo && post.author" class="h6 mb-2 d-none d-md-block">{{ i18nValue.author }}: {{ post.author }}</h3>
      <p class="font-size-sm d-none d-md-block">{{ post.description | stringLimit(300) }}</p>
    </div>
    <div class="d-none d-xl-flex flex-column justify-content-center flex-shrink-0">
      <div class="Post-arrow">
        <svg class="icon-small ml-2">
          <use xlink:href="#icon-chevron-right"></use>
        </svg>
      </div>
    </div>
  </article>
</template>

<script>
const locale = document.documentElement.lang

export default {
  props: {
    post: {
      type: Object
    },
    postInfo: {
      type: Boolean,
      default: true
    },
    link: {
      type: String
    },
    i18n: {
      type: Object,
    }
  },
  data() {
    return {
      i18nValue: {...this.i18n}
    }
  },
  filters: {
    stringLimit: function(e, t) {
      return e ? (e = e.toString()).length <= t ? e : e.substr(0, t) + "..." : ""
    }
  }
};
</script>
